import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find-index.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  class: "fu-group"
};
var _hoisted_2 = {
  key: 0,
  class: "center"
};
var _hoisted_3 = {
  class: "fu-group-tab"
};
var _hoisted_4 = {
  class: "fu-group-content"
};
var _hoisted_5 = {
  key: 2,
  class: "center"
};
import { computed, ref, onMounted } from 'vue';
import { routeAuth } from '@/utils/auth';
import SubTab from '../../Components/SubTab.vue';
import Study from './Study.vue';
import Explore from './Explore.vue';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var tabs = [{
      name: '班级学习小组',
      value: 1,
      component: Study,
      exist: true
    }, {
      name: '小组合作探究',
      value: 2,
      component: Explore,
      exist: false
    }];
    var loading = ref(true);
    var hasAuth = ref(false);
    var defaultIndex = ref(1);
    var currentComponent = computed(function () {
      var index = tabs.findIndex(function (item) {
        return item.value === defaultIndex.value;
      });
      return tabs[index].component;
    });
    var handleChangeTab = function handleChangeTab(item) {
      defaultIndex.value = item.value;
    };
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var auth;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return routeAuth('classSetting');
          case 1:
            auth = _context.v;
            hasAuth.value = auth;
            loading.value = false;
          case 2:
            return _context.a(2);
        }
      }, _callee);
    })));
    return function (_ctx, _cache) {
      var _component_Loading = _resolveComponent("Loading");
      var _component_Empty = _resolveComponent("Empty");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_Loading)])) : _createCommentVNode("", true), !loading.value && hasAuth.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", _hoisted_3, [_createVNode(SubTab, {
        tabs: tabs,
        "default-index": defaultIndex.value,
        onChange: handleChangeTab
      }, null, 8, ["default-index"])]), _createElementVNode("div", _hoisted_4, [(_openBlock(), _createBlock(_resolveDynamicComponent(currentComponent.value)))])], 64)) : _createCommentVNode("", true), !loading.value && !hasAuth.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_Empty, {
        text: "暂无应用权限"
      })])) : _createCommentVNode("", true)]);
    };
  }
};